<template>
  <div
    class="summary-section-container"
  >
    <template>
      <SummarySectionZoom
        v-if="isZoomable && showZoom"
        :title="title"
        @closing="toggleZoom()"
        :zoom-elements="$refs.zoomElements"
      />
      <div
        class="sub-section-title"
        v-if="title"
      >
        {{ title.replaceAll(';', ',') }}
      </div>
      <div
        v-for="(section, index) in this.modifiedSections"
        @click="!section.collapsable || section.section_type === 'sub_section'
          ? toggleZoom() : () => {}"
        :class="`summary-section-sub-container ${section.collapsable ? 'collapsable' : ''}`"
        :key="`section-${section.title}-${index}`"
        ref="zoomElements"
      >
        <SummarySectionLink
          v-if="isLinkButton(section.section_type)"
          :section="section"
        />
        <template
          v-if="section.section_type === 'table'"
        >
          <SummaryTable
            :key="'table' + index + section.title"
            :table="section.table"
            :title="section.title"
          />
        </template>
        <template
          v-if="section.section_type === 'text'"
        >
          <NotesTable
            :title="section.title"
            :text="section.text"
          />
        </template>

        <template
          v-if="section.section_type === 'sub_section'"
        >
          <CollapsableTitle
            v-if="section.collapsable"
            :section="section"
            :index="index"
            @clickCollapsable="clickCollapsable"
          />
          <SummarySectionV2
            v-if="!section.collapsable || section.toggleCollapse"
            :title="section.collapsable ? '' : section.title"
            :depth="section.collapsable ? 3 : depth + 1"
            :key="'section' + index + 'sub' + section.title"
            :sections="section.content"
          />
        </template>

        <template
          v-if="section.section_type === 'section'"
        >
          <CollapsableTitle
            v-if="section.collapsable"
            :section="section"
            :index="index"
            @clickCollapsable="clickCollapsable"
          />

          <SummarySectionV2
            v-if="!section.collapsable || section.toggleCollapse"
            :depth="depth + 1"
            :key="index + section.title + 'inside section'"
            :sections="section.content"
          />
        </template>
      </div>
    </template>
  </div>
</template>

<script>

import SummaryTable from './SummaryTable.vue';
import SummarySectionLink from './SummarySectionLink.vue';
import NotesTable from './NotesTable.vue';
import { isLinkButton } from '../utils';
import SummarySectionZoom from './SummarySectionZoom.vue';
import CollapsableTitle from './CollapsableTitle.vue';

export default {
  name: 'SummarySectionV2',
  components: {
    SummarySectionLink, SummaryTable, NotesTable, SummarySectionZoom, CollapsableTitle,
  },
  props: {
    sections: Array,
    title: String,
    depth: Number,
  },
  data() {
    return {
      modifiedSections: this.sections?.map((section) => ({
        ...section,
        toggleCollapse: false,
      })),
      showZoom: false,
    };
  },
  computed: {
    isZoomable() {
      // only toggle if we are at depth 1 (first sub_section) or 0 if it has no more sub_sections
      // 1 is the typical first main sub_section with zoommable content
      // 0 is the top level which is normally quite large, but when there are no more sub_sections,
      //   it is the right one to zoom, for e.g. Optional P+L only has one sub_section level
      return (this.depth === 1 || (this.depth === 0 && this.sections.filter((s) => s.section_type === 'sub_section').length === 0));
    },
  },
  methods: {
    isLinkButton,
    clickCollapsable(item, index) {
      this.modifiedSections[index].toggleCollapse = !this.modifiedSections[index].toggleCollapse;
    },
    toggleZoom() {
      if (this.isZoomable) {
        this.showZoom = !this.showZoom;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .summary-container-v2 {
    & > .summary-section-container {
      display: flex;
      flex-direction: column;
      width: 95%;
    }
    .sub-section-title {
      padding: 5px 5px;
      font-size: 13px;
      text-align: center;
      text-transform: uppercase;
      font-weight: bold;
      background: white;
    }
  }

  .summary-section-sub-container {
      width: 100%;
      &:not(:last-child) {
        border-bottom: 1px solid $borders;
      }
      &.collapsable {
        border: 0;
      }
  }
  .summary-section-item {
    display: flex;
    flex-direction: column;
    background-color: $surface-light;
    border: 1px solid $borders;
    border-radius: 5px;
  }
</style>
